import { render, staticRenderFns } from "./course-repair-information.vue?vue&type=template&id=62695934&scoped=true&"
import script from "./course-repair-information.vue?vue&type=script&lang=js&"
export * from "./course-repair-information.vue?vue&type=script&lang=js&"
import style0 from "./course-repair-information.vue?vue&type=style&index=0&id=62695934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62695934",
  null
  
)

export default component.exports